import { render } from "./TrainingDetail_AiTraining.vue?vue&type=template&id=342e7960&scoped=true"
import script from "./TrainingDetail_AiTraining.vue?vue&type=script&lang=js"
export * from "./TrainingDetail_AiTraining.vue?vue&type=script&lang=js"

import "./TrainingDetail_AiTraining.vue?vue&type=style&index=0&id=342e7960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342e7960"]])

export default __exports__